import {
  FILTER_MAPPINGS,
  SYNC_TABLE_COLUMNS,
  SYNC_TABLE_GRID_LAYOUT,
} from 'modules/dataWarehouse/constants';
import { Sync } from 'modules/dataWarehouse/types';
import { formatSyncSchedule, getIterableSyncStatus } from 'modules/dataWarehouse/utils';
import { SearchableText } from 'ui-beta/searchableText';
import { Badge } from 'ui/badge';
import { RightTooltip } from 'ui/tooltip';
import { DATE_FORMAT_FULL_WITH_HOURS_MINS_SECONDS, displayDate, getFromNow } from 'utils/date';
import {
  BaseCell,
  CellActions,
  HeaderCell,
  StyledFullWidthGridRow,
  StyledGridRow,
  StyledHeaderGridRow,
} from './SyncsTable.styled';
import { TableOverflowMenu } from './TableOverflowMenu';
import { ZeroStateMessage } from './ZeroStateMessage';

const TableHeader = () => (
  <StyledHeaderGridRow gridLayout={SYNC_TABLE_GRID_LAYOUT}>
    {SYNC_TABLE_COLUMNS.map((column) => (
      <HeaderCell key={column}>{column}</HeaderCell>
    ))}
  </StyledHeaderGridRow>
);

export const SYNCS_TABLE_TEXT = {
  noResultsMessage: 'No results',
};

type SyncTableProps = {
  searchTerm: string;
  sourceId: number;
  syncs: Sync[];
  totalSyncs: number;
};

export const SyncsTable = ({ searchTerm, sourceId, syncs, totalSyncs }: SyncTableProps) => {
  if (totalSyncs === 0) {
    return <ZeroStateMessage sourceId={sourceId} />;
  }

  if (syncs.length === 0) {
    return (
      <>
        <TableHeader />
        <StyledFullWidthGridRow>
          <BaseCell>{SYNCS_TABLE_TEXT.noResultsMessage}</BaseCell>
        </StyledFullWidthGridRow>
      </>
    );
  }

  return (
    <>
      <TableHeader />
      {syncs.map((sync) => {
        const timeFromNow = sync?.lastRunAt ? getFromNow(sync.lastRunAt) : 'N/A';
        const dateToDisplay = displayDate(sync.lastRunAt, DATE_FORMAT_FULL_WITH_HOURS_MINS_SECONDS);
        const iterableSyncStatus = getIterableSyncStatus(sync.status);

        return (
          <StyledGridRow gridLayout={SYNC_TABLE_GRID_LAYOUT} key={sync.id}>
            <BaseCell>
              <SearchableText searchText={searchTerm} text={sync.name} />
            </BaseCell>
            <BaseCell>
              <Badge variant={FILTER_MAPPINGS[sync.status].badgeStatus}>{iterableSyncStatus}</Badge>
            </BaseCell>
            <BaseCell>
              <RightTooltip
                tooltipContent={dateToDisplay}
                isUnderlined
                isEnabled={!!sync.lastRunAt}
              >
                {timeFromNow}
              </RightTooltip>
            </BaseCell>
            <BaseCell>{sync.disabled ? '' : formatSyncSchedule(sync.schedule)}</BaseCell>
            <CellActions>
              <TableOverflowMenu id={sync.id} />
            </CellActions>
          </StyledGridRow>
        );
      })}
    </>
  );
};
